export default {
    en: {
        id: 'exercise1',
        answers: [
            {
                title: `
                <div class="box-title">Could be an opportunity for TLS</div>
                <div>
                    - Addresses our age group
                </div>
                <div>
                    - No dominant player there
                </div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: '<div class="box-title">Identify possible strategy to make it happen</div>',
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Close the gaps, emerge as dominant player</div>`,
                answer: 3,
                hasArrow: true
            },
        ],
        image: '5b1-1.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise1.js